<template>
  <div class="dash">
    <div class="uk-position-center" v-if="!foundData" >
      <div uk-spinner></div>
    </div>

    <div class="uk-container uk-container-small">
        <div class="uk-margin uk-margin-medium-top">
          <form class="uk-search uk-search-default uk-width-1-1">
              <span uk-search-icon></span>
              <input class="uk-search-input" type="search" placeholder="Search Page..." v-bind:style="{backgroundColor:'#fff'}">
          </form>
        </div>
    </div>
    <div class="uk-container uk-container-large" v-if="foundData" >
      <div class="uk-margin-large-top uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-5@l uk-text-center" uk-grid uk-height-match="target: > div > .uk-panel">
        <div v-for="(hotel, index) in hotelList" :key="index">
          <router-link :to="{name:'about',params: { hotelId: hotel.sabreId }}">
            <div class="uk-background-default uk-padding-small uk-panel">
              <p class="uk-h4 uk-text-truncate uk-text-capitalize">{{ hotel.name }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="fab fab-fixed">
      <button uk-toggle="target: #site-modal-overflow" class="btn uk-button btn-float"><i uk-icon="icon: plus" class="uk-icon"></i></button>
    </div>
    <div id="site-modal-overflow" uk-modal>
      <div class="uk-modal-dialog uk-margin-auto-vertical">
        <form class="uk-form-stacked" @submit.prevent="_createHotel" autocomplete="off">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header uk-padding-small">
                <h4 class="uk-modal-titl">Create Hotel</h4>
            </div>
            <div class="uk-modal-body uk-padding-remove-top uk-margin-top">
                <div class="uk-margin">
                    <label class="uk-form-label" for="h_name">Hotel Name</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" id="h_name" v-model="hotel.name" name="hotelName" type="text" placeholder="Hotel Name">
                    </div>
                </div>
                <div class="uk-margin">
                    <label class="uk-form-label" for="h_id">Hotel ID</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" id="h_id" v-model="hotel.sabreId" name="hotelId" type="text" placeholder="Hotel ID">
                    </div>
                </div>
            </div>
            <div class="uk-modal-footer">
                <button class="uk-button uk-button-primary" type="submit">Save</button>
            </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Nav from "@/components/nav";
import { api } from "@/helpers/config";
import utility from "@/helpers/utility";

export default {
  name: "home",
  data: () => ({
    hotelList: [],
    foundData: false, 
    hotel: {
      name: null,
      sabreId: null
    }
  }),
  components: {
    "top-menu": Nav
  },
  created() {
    const el = document.body;
    el.classList.remove("login");
    this._getList();
  },
  methods: {
    _getList() {
      axios.get(api.hotelList).then(response => {
        this.hotelList = response.data.hotels;
        this.foundData = true;
      });
    },
    _createHotel() {
      this.hotel.userId = localStorage.getItem('userId');
      axios.post(api.createHotel,this.hotel).then(response => {
        this._getList();
        utility.hideModal('site-modal-overflow');
        utility.notify(response.data.msg);
      });
    }
  }
};
</script>
